import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

export default function Reject_PopUp({
  setOnReject,
  onReject,
  inputList,
  setTrigger,
  trigger,
  setIndex
}) {
  const token = localStorage.getItem("nodeToken");
  const navigate = useNavigate();
  const onRejectClick = async () => {
    try {
      const reqObject = {
        inputList: inputList,
        Insurance_Flow_Type: "OPS2",
        status: "REJECT",
      };
      const response = await nodeinstance.put(
        `/insurance-dependent/rejectOps`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        setTrigger(!trigger);
        navigate("/dashboard/dependent-addition");
        setOnReject(false)
        setIndex(0);
      }
    } catch (error) {
      console.log("error to be seen here...", error);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          onReject ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setOnReject(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div>
            <h1>Are you sure to reject the dependents?</h1>
          </div>

          <div className="flex gap-3 w-full justify-center" style={{ m: 2 }}>
            <button
              className="p-2 bg-black text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              onClick={() => {
                setOnReject(false);
              }}
            >
              {" "}
              <p>NO</p>
            </button>
            <button
              className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
              onClick={() => {
                onRejectClick();
              }}
            >
              {" "}
              <p>YES</p>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
